import { TextureAtlas } from 'pixi-spine';
import * as PIXI from 'pixi.js';
import { slotFileList } from './pixiConstants';

export const assetsPreload = (): Promise<void> => new Promise((resolve) => {
  const filesToWait = [...slotFileList].map((file) => {
    const { pngFileName } = getFilePaths(file.jsonPath);
    return pngFileName;
  });
  const aviatorPngs = [
    'aviatorSkins/Aviator.png',
    'aviatorSkins/Aviator_2.png',
    'looped_bg/background.png',
    // 'planet/planet.png',
    // 'racoon/racoon.png',
    // 'sun/sun.png',
    // 'ufo/ufo.png',
  ];

  const aviatorData = [
    'aviatorSkins/Aviator.json',
    'aviatorSkins/Aviator.atlas',
    'looped_bg/background.json',
    'looped_bg/background.atlas',
    // 'planet/planet.json',
    // 'planet/planet.atlas',
    // 'racoon/racoon.json',
    // 'racoon/racoon.atlas',
    // 'sun/sun.json',
    // 'sun/sun.atlas',
    // 'ufo/ufo.json',
    // 'ufo/ufo.atlas',
  ];

  const requiredList = [...filesToWait, ...aviatorPngs, ...aviatorData].reduce((acc, fileName) => {
    acc[fileName] = false;
    return acc;
  }, {} as Record<string, boolean>);
  const observer = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    entries.forEach((entry) => {
      const readyKey = Object.keys(requiredList).find((key) => entry.name.includes(key));
      if (readyKey) {
        requiredList[readyKey] = true;
        if (!Object.values(requiredList).includes(false)) {
          checkAllLoaded();
        }
      }
    });
  });
  function checkAllLoaded() {
    if (!Object.values(requiredList).includes(false)) {
      observer.disconnect();
      resolve();
    }
  }
  aviatorPngs.forEach((png) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `/spine/aviator/${png}`, true);
    xhr.responseType = 'blob'; // We want the response to be in Blob format (image data)

    xhr.onload = () => {
      if (xhr.status === 200) {
        const imgBlob = xhr.response; // The Blob containing the image data
        const imgUrl = URL.createObjectURL(imgBlob); // Create a URL for the Blob

        const img = new Image();
        img.src = imgUrl;
        img.onload = () => {
          requiredList[png] = true;
          checkAllLoaded();
          URL.revokeObjectURL(imgUrl); // Clean up the URL object after use
        };
        img.onerror = () => window.console.warn(`Loading error ${png}`);
      } else {
        window.console.warn(`Failed to load image ${png}: ${xhr.status}`);
      }
    };

    xhr.onerror = () => {
      window.console.warn(`XHR Error loading ${png}`);
    };

    xhr.send(); // Send the request
  });

  aviatorData.forEach((file) => {
    fetch(`/spine/aviator/${file}`)
      .then((response) => {
        if (!response.ok) throw new Error(`Loading error ${file}`);
        return response.text();
      })
      .then(() => {
        requiredList[file] = true;
        checkAllLoaded();
      })
      .catch((err) => window.console.warn(err));
  });
  observer.observe({ entryTypes: ['resource'] });
});

export const getFilePaths = (jsonPath: string) => {
  const pathArray = jsonPath.split('/');
  const folder = pathArray.slice(0, pathArray.length - 1).join('/');
  const name = jsonPath.split('/').pop()?.replace('.json', '');
  const atlasPath = `${folder}/${name}.atlas`;
  const pngPath = `${folder}/${name}.png`;
  const pngFileName = `${name}.png`;
  return {
    folder, atlasPath, name, pngPath, pngFileName,
  };
};
export async function loadSpineAtlas(path: string) {
  const { atlasPath, folder } = getFilePaths(path);
  const rawAtlas = await fetch(atlasPath).then((res) => res.text());
  return new TextureAtlas(rawAtlas, ((line, callback) => {
    callback(PIXI.BaseTexture.from(`${folder}/${line}`));
  }));
}
